import React, { Fragment, SetStateAction, useState } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { ErrorMessage, Field } from "@atlaskit/form";

export const numberOfUsersProductErrorMessage = {
    id: "migrationOptions.numberOfUsersProductErrorMessage",
    defaultMessage: "Enter the number of users for this product."
};

export const NumberOfUsersField = (
    setFieldValue: (name: string, value: unknown) => void
) => {
    const intl = useIntl();

    return (
        <div css={css({ paddingBlockStart: "36px" })}>
            <Field
                name={"numberOfUsers"}
                label={
                    useIntl().formatMessage({
                        id: "migrationOptions.numberOfUsersForProduct",
                        defaultMessage: "Number of users for this product"
                    }) + " *"
                }
            >
                {({ fieldProps, error }) => (
                    <Fragment>
                        <NumberOfUsersInput
                            {...fieldProps}
                            onChangeHandler={(numberOfUsers) => {
                                setFieldValue(
                                    "numberOfUsers",
                                    Number(numberOfUsers)
                                );
                                fieldProps.onChange;
                            }}
                        />
                        {error && (
                            <ErrorMessage>
                                {intl.formatMessage(
                                    numberOfUsersProductErrorMessage
                                )}
                            </ErrorMessage>
                        )}
                    </Fragment>
                )}
            </Field>
        </div>
    );
};

interface NumberOfUsersProps {
    onChangeHandler?: React.Dispatch<SetStateAction<string>>;
}

export const NumberOfUsersInput = ({ onChangeHandler }: NumberOfUsersProps) => {
    const [numberOfUsers, setNumberOfUsers] = useState("");

    const inputStyle = css({
        "boxSizing": "border-box",
        "display": "block",
        "paddingInlineStart": "13px",
        "paddingInlineEnd": "20px",
        "minHeight": "48px",
        "width": "100%",
        "fontWeight": "400",
        "letterSpacing": "normal",
        "textAlign": "start",
        "lineHeight": "2",
        "borderRadius": "5px",
        "color": "#253858",
        "backgroundColor": "#f4f5f7",
        "border": "none",
        "borderImageOutset": "0",
        "borderImageRepeat": "stretch",
        "borderImageSlice": "100%",
        "cursor": "text",
        "WebkitAppearance": "none",
        ":focus": {
            borderColor: "#0049b0",
            borderStyle: "solid",
            borderWidth: "1px",
            outline: "0"
        },
        ":focus-visable": {
            borderColor: "#0049b0",
            borderStyle: "solid",
            borderWidth: "1px",
            outline: "0"
        }
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setNumberOfUsers(inputValue);
        onChangeHandler?.(inputValue);
    };

    return (
        <input
            css={inputStyle}
            type="number"
            min="1"
            value={numberOfUsers}
            onChange={handleChange}
        />
    );
};
